import { createContext, useContext } from 'react';
var noop = function noop() {};
export var ExperienceTrackerAdapterContext = /*#__PURE__*/createContext({
  start: noop,
  startWithDeps: noop,
  succeed: noop,
  fail: noop,
  abort: noop,
  stopOnError: noop,
  subscribe: function subscribe() {
    return noop;
  },
  markStart: noop,
  markEnd: noop,
  abortAll: noop
});
export var useExperienceTracker = function useExperienceTracker() {
  return useContext(ExperienceTrackerAdapterContext);
};